import { apiFetch } from './fetchApi';

export const TestFecthJobHistory = async ({ BeURL, setJobHistory, showAlert }) => {
    try {
        const res = await apiFetch(`${BeURL}/fetch-job-history`, {
            method: "GET",
            credentials: "include",
        });

        const data = await res.json();

        if (data.success) {
            setJobHistory(data.data || []);
        } else {
            showAlert?.(data.message || "Failed to fetch jobs", "error");
        }
    } catch (err) {
        console.error("Error in fetch job:", err);
        showAlert?.("Failed to fetch jobs", "error");
    }
};